import React from "react";
import { Table, Spin } from "antd";;

const { Column } = Table;

const AppThemConfigTable = ({
  AppThemData,
  loading,
  deleteRecord
}) => {

  return (
    <Spin spinning={loading}>
      <Table dataSource={AppThemData} rowClassName="table-row-light">
        {/* <Column
          title="Title Background Color"
          dataIndex="headerBgColor"
          key="headerBgColor"
        /> */}
        <Column
          title="Header Icon"
          key="headerIcon"
          render={(text, record) => (
            <img
              alt="card"
              className="thumbnail"
              src={
                record.headerIcon
                  ? record.headerIcon
                  : "https://pngimage.net/wp-content/uploads/2018/06/placeholder-png-4.png"
              }
            />
          )}
        />
        <Column
          title="Action"
          key="name"
          width={200}
          render={(text, record) => (
            <span>
              <a
                onClick={() => deleteRecord(record)}
                style={{ marginRight: 16, cursor: "pointer" }}
              >
                Delete
              </a>
            </span>
          )}
        />
      </Table>
    </Spin>
  );
};

export default AppThemConfigTable;
